export default __webpack_public_path__ + "static/media/lets.c42c89df.jpg";